/**
 * join.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";

// TODO: does it need to be impure? judge usage...
/**
 * join is a pipe that simply applies Array.prototype.join to its input.
 */
@Pipe({name: "join", pure: false})
export class JoinPipe implements PipeTransform {
  /**
   * Verify the input is an array, then join its elements using the provided
   * delimeter, or by default, a comma and space.
   * @param  {any[]}     value
   * @param  {dtring} delimiter
   * @return {any}
   */
  public transform (value : any[], delimiter : string = ", ") : any
  {
    if (value === null)
    {
      return null;
    }
    if (value === undefined)
    {
      return undefined;
    }
    if (!Array.isArray(value))
    {
      console.warn("Join pipe operating on non-array:", value);
      return "~";
      // throw new Error("Join only works on arrays!");
    }
    return value.join(delimiter);


  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/join.pipe.ts